import { CONTROL } from '../../../../components';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var FUNCTION_GRAPH_FORM_CONFIG = {
  ui: [['requestsCount', 'memoryVolume'], 'memoryVolumeAlert', ['computationTime'], 'requestsCountAlert'],
  controls: {
    requestsCount: {
      type: CONTROL.Stepper,
      accessorKey: 'requestsCount',
      defaultValue: 0,
      decoratorProps: {
        label: 'Количество запросов'
      },
      uiProps: {
        min: 0,
        max: 9999999999,
        step: 1,
        multiplier: 1000000,
        showHint: false,
        postfix: 'млн'
      }
    },
    memoryVolume: {
      type: CONTROL.Stepper,
      accessorKey: 'memoryVolume',
      defaultValue: 1,
      decoratorProps: {
        label: 'Объем памяти',
        labelTooltip: 'Объем выделяемый для выполнения одной функции'
      },
      uiProps: {
        min: 128,
        max: 4194304,
        postfix: 'МБ'
      }
    },
    memoryVolumeAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: /*#__PURE__*/_jsx(_Fragment, {
          children: "\u041F\u0435\u0440\u0432\u044B\u0435 2\xA0000\xA0000 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
        })
      },
      accessorKey: 'first-free'
    },
    computationTime: {
      type: CONTROL.Stepper,
      accessorKey: 'computationTime',
      defaultValue: 0,
      decoratorProps: {
        label: 'Продолжительность вычислений',
        labelTooltip: 'Максимальная продолжительность выполнения одной функции'
      },
      uiProps: {
        min: 0,
        max: 900,
        postfix: 'сек'
      }
    },
    requestsCountAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: /*#__PURE__*/_jsx(_Fragment, {
          children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439 \u0432\xA0\u0440\u0430\u0437\u043C\u0435\u0440\u0435 400\xA0000\xA0\u0413\u0411/\u0441 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
        })
      },
      accessorKey: 'free'
    }
  }
};